import React from 'react';
import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

const BarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
  padding: 0px 4px 38px;

  ${props => props.$isMobile && css`
    padding: 12px 16px;
  `}
`;

const BookButton = styled(motion.button)`
  flex: 1;
  background: #2563eb;
  color: white;
  font-weight: 700;
  font-size: 15px;
  padding: 16px 24px;
  border-radius: 16px;
  border: none;
  cursor: pointer;
  box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.3),
              0 4px 6px -2px rgba(37, 99, 235, 0.15);
  transition: all 0.2s ease;

  &:hover {
    background: #1d4ed8;
    transform: translateY(-1px);
    box-shadow: 0 12px 20px -3px rgba(37, 99, 235, 0.4),
                0 6px 8px -2px rgba(37, 99, 235, 0.2);
  }

  &:active {
    transform: scale(0.98);
  }

  ${props => props.$isMobile && css`
    padding: 14px 20px;
    font-size: 14px;
    border-radius: 12px;
  `}
`;

const formatCost = (cost, currency) => {
  if (!cost) return null;
  if (typeof cost === 'string') return cost;
  if (typeof cost !== 'number' || Number.isNaN(cost)) return null;
  try {
    return new Intl.NumberFormat('en', {
      style: 'currency',
      currency: currency || 'USD',
      maximumFractionDigits: 0,
    }).format(cost);
  } catch {
    return `$${cost.toLocaleString()}`;
  }
};

const BottomCostBar = ({ estimatedCost, currency, onBookAll, isMobile }) => {
  const formattedCost = formatCost(estimatedCost, currency);
  if (!formattedCost) return null;

  return (
    <BarContainer $isMobile={isMobile}>
      <BookButton
        $isMobile={isMobile}
        onClick={onBookAll}
        whileTap={{ scale: 0.97 }}
      >
        Estimated Budget: {formattedCost}
      </BookButton>
    </BarContainer>
  );
};

export default BottomCostBar;
